import { useEffect } from 'react';
import { getUserId } from '@peloton/auth/redux';
import { setDisplayLanguage } from '@peloton/time/time';
import { isDefined } from '@peloton/types/isDefined';
import { useReduxState, useReduxAction } from '@engage/redux/hooks';
import { getDisplayLanguage, updateDisplayLanguage } from '@engage/settings/redux';
import { getPersistedOrBrowserDisplayLanguage } from './persistLanguage';
import { toSupportedBrowserLanguage } from './toSupportedBrowserLanguage';

export const LocaleSetter = ({ children }: { children: JSX.Element }) => {
  const userId = useReduxState(getUserId);
  const displayLanguage = useReduxState(getDisplayLanguage);
  const updateDisplayLanguageAction = useReduxAction(updateDisplayLanguage);

  useEffect(() => {
    if (userId) {
      const storedDisplayLanguage = getPersistedOrBrowserDisplayLanguage()(userId);
      updateDisplayLanguageAction(storedDisplayLanguage);
    }
  }, [userId]);

  useEffect(() => {
    if (isDefined(displayLanguage)) {
      setDisplayLanguage(displayLanguage);
    } else if (!userId) {
      const supportedBrowserLanguage = toSupportedBrowserLanguage();
      updateDisplayLanguageAction(supportedBrowserLanguage);
      setDisplayLanguage(supportedBrowserLanguage);
    }
  }, [displayLanguage]);

  return children;
};
